import { PermissoesService } from './../../../service/usuario/permissoes.service';
import { ActivatedRoute } from '@angular/router';
import { ResponsePageable } from 'app/model/cliente/pageable/responsePageable.model';
import { ClienteService } from '../../../service/cliente/cliente.service';
import { ArmazemService } from '../../../service/endereco/armazem.service';
import { HttpClient } from '@angular/common/http';
import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { MatTableDataSource, MatPaginator, MatSort } from '@angular/material';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ClienteModel } from 'app/model/cliente/cliente.model';
import { ArmazemModel } from 'app/model/endereco/armazem.model';
import { EnderecoModel } from 'app/model/endereco/endereco.model';
import { TipoEnderecoModel } from 'app/model/endereco/tipoendereco.model';
import { EnderecoService } from 'app/service/endereco/endereco.service';
import { TipoenderecoService } from 'app/service/endereco/tipoendereco.service';
import 'rxjs/add/operator/map';
import * as CryptoJS from 'crypto-js';
import { MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';


@Component({
  selector: 'app-enderecos',
  templateUrl: './enderecos.component.html',
  styleUrls: ['./enderecos.component.scss']
})
export class EnderecosComponent implements OnInit {

  mask = ['(', /[1-9]/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]

  public enderecoForm: FormGroup;

  public submit = false;

  tipoendereco = {} as TipoEnderecoModel;
  tipoenderecos: TipoEnderecoModel[];

  endereco = {} as EnderecoModel;
  enderecos: EnderecoModel[];
  @ViewChild(MatPaginator) paginatorEndereco: MatPaginator;
  @ViewChild(MatSort) sortEndereco: MatSort;
  dataSourceEndereco = new MatTableDataSource<EnderecoModel>([]);
  displayedColumnsEndereco = ['cod','regiao','cep','logradouro','numero','bairro','cidade','uf','acoes'];

  enderecoCliente = {} as EnderecoModel;
  enderecoClientes: EnderecoModel[];

  armazem = {} as ArmazemModel;
  armazems: ArmazemModel[];

  cliente = {} as ClienteModel;
  clientes: ClienteModel[];

  public page: ResponsePageable;

  public pageAtual = 0;

  public edited = false;
  public editado = false;
  public errorAlert = false;
  public successDelete = false;
  public arrayString: string;
  public creatorEndereco = false;
  public editorEndereco = false;
  public listaEndereco = false;
  public deletaEndereco = false;
  public superUser = false;

  @Input() clienteProp: ClienteModel;
  @Input() clientePropId: number;
  @Input() idNovoCliente: number;
  @Input() novoCliente: ClienteModel;
  horizontalPosition: MatSnackBarHorizontalPosition = 'right';
  verticalPosition: MatSnackBarVerticalPosition = 'top';

  public clienteId: any;
  public deData: any;
  msgError = '';

  constructor(
    public enderecoService: EnderecoService,
    private fb: FormBuilder,
    private _snackBar: MatSnackBar,
    private tipoEnderecoService: TipoenderecoService,
    private http: HttpClient,
    private armazemService: ArmazemService,
    private clienteService: ClienteService,
    private route: ActivatedRoute,
    private permissionService: PermissoesService) {
      this.route.params.subscribe(params => this.clienteId = params['id']);
      this.deData = CryptoJS.AES.decrypt(decodeURIComponent(this.clienteId), 'pcdoc');
      this.clienteId = JSON.parse(this.deData.toString(CryptoJS.enc.Utf8));
     }

  ngOnInit() {
    this.enderecoForm = this.fb.group({
      cep: ['', [Validators.required]],
      logradouro: ['', [Validators.required]],
      numero: ['', [Validators.required]],
      complemento: ['', [Validators.required]],
      uf: ['', [Validators.required]],
      bairro: ['', [Validators.required]],
      cidade: ['', [Validators.required]],
      telefone1: [''],
      telefone2: [''],
      ativo: [true, Validators.required],
      tipoEndereco: [TipoEnderecoModel, [Validators.required]],
      armazem: [ArmazemModel , [Validators.required]],
      cliente: [ClienteModel , [Validators.required]],
    });
    // this.enderecoForm.get('ativo').setValue(true);
    // this.getEnderecos();
    this.getTipoEndereco();
    this.getArmazem();
    this.getEnderecoCliente(this.clienteId);
    this.getAuthority();
  }

  getAuthority() {
    this.getItemAuthority('authority');
    if (this.arrayString.includes('ADD_EMPRESA')) {
      this.creatorEndereco = true;
    }
    if (this.arrayString.includes('EDIT_EMPRESA')) {
      this.editorEndereco = true;
    }
    if (this.arrayString.includes('LIST_EMPRESA')) {
      this.listaEndereco = true;
    }
    if (this.arrayString.includes('DELETE_EMPRESA')) {
      this.deletaEndereco = true;
    }
    if (this.arrayString.includes('SUPER_USER')) {
      this.superUser = true;
    }
  }

  getItemAuthority(key) {
    const store = sessionStorage.getItem(key);
    if (store) {
      try {
        const bytes = CryptoJS.AES.decrypt(
          store,
          sessionStorage.getItem('ticket-ECM')
        );
        this.arrayString = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
        return this.arrayString;
      } catch (e) {
        sessionStorage.clear();
      }
    }

    return null;
  }

  getDados() {
    this.getArmazem();
    this.getTipoEndereco();
  }

  changePage(event){
    this.listPageEndereco(event.page, event.size);
    this.pageAtual = event.page;
  }

  onSubmit(){
    this.submit = true;
  }

  postSubmit(){
    this.submit = false;
    this.enderecoForm.reset();
  }

  aplicarFiltros(filter: string) {
    filter = filter.trim();
    filter = filter.toLowerCase();
    this.dataSourceEndereco.filter = filter;
  }

  listPageEndereco(page, size){
    this.enderecoService.getPageEndereco(page, size).subscribe(res => {
      this.page = res;
      this.enderecos = this.page.content;
    });
  }

  getEnderecoCliente(id: number) {
    this.enderecoService.getEnderecosCliente(id).subscribe( data => {
      this.enderecos = data;
      this.dataSourceEndereco = new MatTableDataSource(this.enderecos);
      this.dataSourceEndereco.paginator = this.paginatorEndereco;
      this.dataSourceEndereco.sort = this.sortEndereco;
      console.log(this.dataSourceEndereco);
    }, error => {
      console.error(error);
    });
  }

  getDadosEnderecoEdit(endereco: EnderecoModel){
    this.endereco = { ...endereco}
    this.enderecoForm.get('tipoEndereco').setValue(endereco.tipoEndereco);
    this.enderecoForm.get('armazem').setValue(endereco.armazem);
    this.enderecoForm.get('cliente').setValue(endereco.cliente);
  }

  compararEditEndereco(obj1, obj2) {
    return obj1 && obj2 ? (obj1.descricao === obj2.descricao && obj1.id === obj2.id) : obj1 === obj2;
  }


  clickNovoEndereco(){
    this.endereco.id = undefined;
    this.getDados();
  }

  saveOrEditEndereco(){
    if(this.endereco.id !== undefined){
      this.editarEndereco();
    } else {
      this.adicionarEndereco();
    }
  }

  adicionarEndereco() {
    this.enderecoForm.get('cliente').setValue(this.clienteProp);
    this.enderecoService.postEndereco(this.enderecoForm.value).subscribe(endereco => {
      this.endereco = new EnderecoModel();
      this.enderecoForm.reset();
      this.openSnackBarSuccess('Endereço salvo com sucesso !');
      this.postSubmit();
      this.getEnderecoCliente(this.clientePropId);
    }, err => {
      console.log(err);
      this.openSnackBarError('Erro ao tentar adicionar o Endereço !');
    });
  }

  editarEndereco() {
    this.enderecoService.putEndereco(this.endereco).subscribe(result => {

        this.getEnderecoCliente(this.clientePropId);
        this.openSnackBarSuccess('Endereço atualizado com sucesso !');
    }, err => {
      console.log(err);
      this.openSnackBarError('Erro ao tentar atualizar o Endereço !');
    });
  }

  getArmazem() {
    this.armazemService.getArmazem().subscribe(data => {
      this.armazems = data.content;
    });
  }

  getEnderecos(){
    this.enderecoService.getEndereco().subscribe(data => {
      this.enderecos = data.content;

    });
  }

  getTipoEndereco(){
    this.tipoEnderecoService.getTipoEnderecos().subscribe(data => {
      this.tipoenderecos = data.content;
    });
  }

  consultaCEP(cep){
    // Nova variável "cep" somente com dígitos.
    cep = cep.replace(/\D/g, '');

    // Verifica se campo cep possui valor informado.
    if (cep !== "") {

      // Expressão regular para validar o CEP.
      var validacep = /^[0-9]{8}$/;

       // Valida o formato do CEP.
       if (validacep.test(cep)) {

        this.http.get(`//viacep.com.br/ws/${cep}/json`)
          .map(dados => dados)
          .subscribe(dados =>  this.populaDadosFormEndereco(dados));
       }
    }
  }

  populaDadosFormEndereco(dados) {
    this.enderecoForm.get('logradouro').setValue(dados.logradouro);
    this.enderecoForm.get('cep').setValue(dados.cep);
    if (dados.complemento !== '') {
      this.enderecoForm.get('complemento').setValue(dados.complemento);
    }
    this.enderecoForm.get('bairro').setValue(dados.bairro);
    this.enderecoForm.get('uf').setValue(dados.uf);
    this.enderecoForm.get('cidade').setValue(dados.localidade);
    // enderecoForm = this.enderecoForm.setValue({
    //   logradouro: dados.logradouro,
    //   cep: dados.cep,
    //   complemento: dados.complemento,
    //   bairro: dados.bairro,
    //   uf: dados.uf,
    //   cidade: dados.localidade
    //   numero: "",
    //   telefone1: "",
    //   telefone2: "",
    //   ativo: null,
    //   tipoEndereco: null,
    //   armazem: null,
    //   cliente: null
    // });
  }

  confirmeExclusao(id: number){
    var confirme = confirm("Tem certeza que deseja excluir este endereço ?")
    if(confirme == true){
      this.apagarEndereco(id);
    } else {
      console.log("Cancelou exclusão!");
    }
  }

  apagarEndereco(id: number){
    this.enderecoService.deleteEndereco(id).subscribe(endereco => {
      this.endereco = new EnderecoModel();
      this.listPageEndereco(0, 10);
      this.openSnackBarSuccess('Endereço excluído com sucesso !');
    }, error => {
      console.log(error);
      this.openSnackBarError('Erro ao tentar excluir o Endereço !');
    })
  }

// SnackBares
openSnackBarSuccess(message: string) {
  this._snackBar.open(message, '', {
    horizontalPosition: this.horizontalPosition,
    verticalPosition: this.verticalPosition,
    duration: 4000,
    panelClass: ['success-snackbar']
  });
}

openSnackBarError(message: string) {
  this._snackBar.open(message,'', {
    horizontalPosition: this.horizontalPosition,
    verticalPosition: this.verticalPosition,
    duration: 3000,
    panelClass: ['error-snackbar']
  });
}

}



// WEBPACK FOOTER //
// /app/src/app/components/endereco-components/enderecos/enderecos.component.ts